module.exports = __webpack_public_path__ + "static/media/LaurenOne.b2389e0b.jpg";